import * as ts from '../../common/Translator'
import {EditScreenGroup} from "./EditScreenGroup";
import * as actionBlock from "./EditActionBlock";
import {areEqual, nextId} from "../../common/NamaCommon";
import {NamaGridWidget} from "../../grid/NamaGridWidget";
import {EmbeddedListView} from "./EmbeddedListView";
import {EmbeddedReportAndDashboardView} from "./EmbeddedReportAndDashboardView";
import * as DomainBaseFieldIDs from "../../constants/DomainBaseFieldIDs";
import * as BSEntities from "../../constants/BSEntities";
import {FlatDTOCriteriaEditor} from "./FlatDTOCriteriaEditor";
import {DiscussionRecordWidget} from "./DiscussionRecordWidget";
import {isPageHidden} from "../../routing/EditPresenter";
import EditScreenTemplate from "../../compiled-templates/EditScreenTemplate";
import {initEditScreenToolbar} from "./EditScreenToolbar";

/**
 *
 * @param appendTo {NamaJquery|HTMLElement}
 * @param presenter {EditPresenter}
 * @returns {*|NamaJquery|HTMLElement}
 */
export function drawEditScreen(appendTo, presenter) {
    let splitterContainer = $(EditScreenTemplate());
    initEditScreenToolbar(splitterContainer.find(".toolbar"), presenter);
    let container = splitterContainer.find("#tabstrip");
    let previousTabIndex = -1;
    presenter.container = splitterContainer;
    container.kendoTabStrip({
        animation: false,
        select: (e) => {
            let selectedIndex = $(e.item).index();
            if (previousTabIndex !== -1)
                presenter.onPageChanged(selectedIndex);
            previousTabIndex = selectedIndex;
        },
        scrollable: true,
    });
    drawPagesContent(container, presenter, 0);
    splitterContainer.appendTo(appendTo);
    return appendTo;
}

export function setHeightOfToolBar(splitterContainer) {
    if (_setHeightOfToolBar(splitterContainer))
        return;
    setTimeout(() => _setHeightOfToolBar(splitterContainer), 0);
}

function _setHeightOfToolBar(splitterContainer) {

    let originalHeightOfQuickIcons = splitterContainer.find(".tabs .quick-icons-one-invoice").innerHeight();
    let heightOfQuickIcons = originalHeightOfQuickIcons || 75;
    let heightOfTabs = splitterContainer.find(".tabs .k-tabstrip-items-wrapper").innerHeight() || 56;
    let heightOfTitle = splitterContainer.find(".title").innerHeight() || 27;

    splitterContainer.find(".tabs .quick-icons-one-invoice").css("margin-top", heightOfTabs + heightOfTitle);
    splitterContainer.find(".tabs .k-tabstrip-items-wrapper").css("margin-bottom", heightOfQuickIcons);
    let navbarHeight = splitterContainer.parent().find(".navbar").innerHeight();
    let maxHeight = $(window).height();
    splitterContainer.find(".k-tabstrip-content").css("height", maxHeight - navbarHeight - heightOfTitle - heightOfTabs - 50);
}

/**
 * @param container {NamaJquery}
 * @param presenter {EditPresenter}
 * @returns {*|NamaJquery|HTMLElement}
 */
export function drawPagesContent(container, presenter, oldPagesCount) {
    let pages = presenter.editLayout.pages;
    let tabStripData = container.data("kendoTabStrip");
    presenter.noGroupsAdded = true;
    let addedPages = 0;
    for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
        if (isPageHidden(pages[pageIndex], presenter.entityType, pageIndex))
            continue;
        let actualPageIndex = oldPagesCount + addedPages;
        presenter.setDrawingPageIndex(actualPageIndex);
        let pageContent = drawPage(actualPageIndex, pages[pageIndex], presenter.metadata, presenter);
        let page = presenter.editLayout.pages[pageIndex];
        let title = ts.translateNaMaText(page.title, presenter.entityType) || ts.translateId("main", presenter.entityType);
        let divId = nextId();
        tabStripData.append({text: title, content: `<div class=" info" id="${divId}"></div>`})
        container.find("#" + divId).append(pageContent);
        addedPages++;
    }
}

function isDiscussionBlock(block) {
    return block.editScreenBlock && areEqual(block.fieldId, "discussions");
}

function createBlockWidgetFor(presenter, block, groups) {
    if (isDiscussionBlock(block)) {
        let discussionRecordWidget = new DiscussionRecordWidget(block, presenter, groups);
        presenter.addToDiscussionWidgets(discussionRecordWidget);
        discussionRecordWidget.render();
    }
    if (isCriteriaDefinitionCriteria(block, presenter.metaData))
        return new FlatDTOCriteriaEditor(block, presenter, getOwnerTypeField(presenter.metaData.owner.ownerId)).render();
}

function isCriteriaDefinitionCriteria(block, metaData) {
    return areEqual(metaData.owner.ownerId, BSEntities.CriteriaDefinition)
        && areEqual(block.fieldId, DomainBaseFieldIDs.CriteriaDefinition_criteria);
}

function getOwnerTypeField(ownerId) {
    if (areEqual(ownerId, BSEntities.CriteriaDefinition))
        return DomainBaseFieldIDs.CriteriaDefinition_forType;
    return null;
}


/**
 *
 * @param pageIndex {number}
 * @param page
 * @param metaData
 * @param presenter {EditPresenter}
 * @returns {*|NamaJquery|HTMLElement}
 */
function drawPage(pageIndex, page, metaData, presenter) {
    let groupsContainer = $(`<div class="container-fluid px-1 pb-2 pb-md-0"></div>`);
    for (let i = 0; i < page.blocks.length; i++) {
        let block = page.blocks[i];
        let groupContainer = createPageGroupsContainer(block);
        groupsContainer.append(groupContainer);
        let groups = groupContainer.find(".info-body");
        let groupHeader = groupContainer.find(".toggle-info");
        if (block.editScreenGroup) {
            let groupWidget = new EditScreenGroup().drawGroup(block, metaData, presenter, i, groupHeader);
            presenter.noGroupsAdded = false;
            if (!groupWidget)
                continue;
            groups.append(groupWidget);
            if (block.title)
                presenter.addWidgetToSearchableWidgets(pageIndex, groupWidget.find(".widgetsList"), block, block.title.resourceId);
        } else if (block.editScreenGrid) {
            let hasFields = NamaGridWidget.hasColumns(block, metaData, presenter);

            if (hasFields) {
                groups.append(new NamaGridWidget({
                    owner: presenter,
                    grid: block,
                    metaData: metaData,
                    id: block.fieldId,
                    gridHeader: groupHeader,
                    groupNum: i
                }).createElement())
            }
        } else if (block.editScreenDashBoard) {
            groups.append(new EmbeddedReportAndDashboardView({
                owner: presenter,
                block: block,
                editPresenter: presenter,
                forDashBoard: true,
                groupHeader: groupHeader,
                groupContent: groups
            }).createElement());
        } else if (block.editScreenActionsBlock) {
            let editActionBlock = new actionBlock.EditActionBlock(block, metaData, presenter);
            if (editActionBlock.hasActions) {
                let actionBlockElement = editActionBlock.render(presenter.entityType);
                groups.parent().find(".toggle-info").remove();
                groups.append(actionBlockElement);
                presenter.addActionBlockToSearchableWidgets(pageIndex, editActionBlock, actionBlockElement);
            }

        } else if (block.editScreenList) {
            groups.append(new EmbeddedListView({
                owner: presenter,
                block: block,
                editPresenter: presenter,
                groupHeader: groupHeader,
                groupContent: groups
            }).createElement());
        } else if (block.editScreenReport) {
            groups.append(new EmbeddedReportAndDashboardView({
                owner: presenter,
                block: block,
                editPresenter: presenter,
                groupHeader: groupHeader,
                groupContent: groups
            }).createElement());
        } else if (block.editScreenBlock) {
            groups.append(createBlockWidgetFor(presenter, block, groups));
        }
        if (groups.children().length == 0) {
            groupsContainer.find(".nama-collapsable:last").remove();
        }
    }
    return groupsContainer;
}

export function initToggleHeaders() {
    $("body").on('click', ".toggle-info.bg-light", function () {
        $(this).closest(".border.border-light").find(".info-body").slideToggle(1000, () => {
            $(this).trigger("namaCollapse");
        });
        let item = $(this).closest(".border.border-light").find(".toggle-info i.fa-angle-up");
        item.toggleClass("rotate");
        let groupContainer = $(this).parent(".nama-collapsable");
        let nextGroup = groupContainer.next(".nama-collapsable");
        if (item.hasClass("rotate")) {
            if (nextGroup && nextGroup.hasClass('gridDetailedEditor')) {
                nextGroup.hide();
            }
            saveGroupStatToLocalStorage(item, true);
        } else {
            saveGroupStatToLocalStorage(item);
            if (nextGroup && nextGroup.hasClass('gridDetailedEditor')) {
                nextGroup.show();
            }
        }
    });
}

export function saveGroupStatToLocalStorage(item, collapse) {
    let collapseId = item.closest(".toggle-info.bg-light").attr("collapseId");
    if (!collapseId)
        return;
    if (collapse)
        localStorage.setItem(collapseId, "true");
    else
        localStorage.setItem(collapseId, "false");
}

export function createPageGroupsContainer(block, elementId, titleClass, klass) {
    return $(`
        <div ${elementId ? 'id="' + elementId + '"' : ''} class="${klass || ""} nama-collapsable border border-light mb-1">
                <div class="toggle-info bg-light d-flex justify-content-between p-1">
                    <div class=" mb-1 mb-md-0">
                        <span ${titleClass ? 'class="' + titleClass + '"' : ''}></span>
                    </div>
                    <i class="fa-solid fa-angle-up text-secondary"></i>
                </div>
                
                <div class="info-body widgetsList row w-100 m-auto align-items-center ${block.editScreenGrid ? "" : "py-1"}">
                </div>
        </div>
    `);
}